// @flow

import { fetchRest } from "../../rest/rest";

export const CLEAR_STOPS = "state.blogs.CLEAR_STOPS";
export const FETCH_STOPS_SUCCESS = "state.blogs.FETCH_STOPS_SUCCESS";
export const FETCH_STOPS_ERROR = "state.blogs.FETCH_STOPS_ERROR";
export const SENT_MESSAGE = "state.blogs.SENT_MESSAGE";

export const fetchStops = () => async dispatch => {
    try {
        dispatch({ type: CLEAR_STOPS });
        const stops = await fetchRest("stops");
        dispatch({ type: FETCH_STOPS_SUCCESS, payload: stops });
    } catch (err) {
        err.message = `Unable to retrieve stops: ${err.message}`;
        console.log(err);
        dispatch({ type: FETCH_STOPS_ERROR, payload: err });
    }
};



// WEBPACK FOOTER //
// ./src/state/map/actions.js